module.exports = "/_next/static/images/harajuku_alone_lunch-5f4e47e1ce22864856b7de0b055d3397.jpg";